import React from 'react';
import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import aiRenderLogo from '../../assets/aiRenderLogo2.png';
import {
    authListener,
} from '../../Redux/actions';


const SplashScreen = () => {
    return  (
        <div className='splashScreen-section'>
            <img src={aiRenderLogo} className='splashScreen-Image'/>
            <div className='splashScreen-text'>
                Welcomes you!
            </div>
        </div>
    )
}

export default SplashScreen;